import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    DOCUMENT_LIST: {
        url: "beheer/document-list",
        method: "post",
    },

    COMMUNITY_CONTRACT_LIST: {
        url: "gebruiker/get-communitycontract-list",
        method: "get",
    },
};

export const useDocumentList = () =>
    useApiFetcherSWR(API_ENDPOINT.DOCUMENT_LIST);

export const useCommunityContractList = () =>
    useApiFetcherSWR(API_ENDPOINT.COMMUNITY_CONTRACT_LIST);